export default __webpack_public_path__ + "static/more-money-promo-37be35b6d12c7ea6a89febea46cc7165.webp";